<nav class="navbar navbar-top navbar-expand-md navbar-dark" id="navbar-main">

  <i *ngIf="!windowsAgent && !isMobile" class="cursor-pointer float-right w-5 text-white fas fa-expand mr-4 mt-2 fixed-top-right" (click)="toggleFullScreen()"></i> 

  <div class="container-fluid pl-4 pr-4">
    <!-- Brand -->
    <a class="h2 mb-0 text-white text-uppercase" routerLinkActive="active" (click)="refresh()">
      <img [src]="imagePath" class="navbar-brand-img">
      <span class="ml-3"> Dashboard {{ getTitle() ? ' / ' + getTitle() : null }} </span>
    </a>

    <!-- Form -->
    <!-- <form class="navbar-search navbar-search-dark form-inline mr-3 d-none d-md-flex ml-lg-auto">
      <div class="form-group mb-0" [ngClass]="{ 'focused': focus === true }">
        <div class="input-group input-group-alternative">
          <div class="input-group-prepend">
            <span class="input-group-text"><i class="fas fa-search"></i></span>
          </div>
          <input class="form-control" placeholder="Search" type="text" (focus)="focus = true"
          (blur)="focus = false">
        </div>
      </div>
    </form> -->
    <!-- User -->


    <ul class="navbar-nav align-items-center d-none d-sm-flex">
     
      <h1 class="clock" *ngIf="!isMobile && (configuration==null || configuration.currentWeatherMain==null)">    {{ currentTimeString }} <i class="text-white fas fa-clock m-1"></i> </h1>

       <div class="widget" *ngIf="!windowsAgent && !isMobile && configuration && configuration.currentWeatherMain!=null">
            
        <div class="left-panel panel">
            <div class="city clock">
              {{ currentTimeString }}  
            </div>
            <div class="temp" >
               <img [src]="'https://openweathermap.org/img/wn/' + configuration.currentWeatherIcon + '@2x.png'" class="image-temp">
               <span>{{ configuration.currentTemperature | number: '1.0-0' }}&deg;</span>
            </div>
        </div>
        <div class="right-panel panel">
            <div class="wind">
               {{ configuration.currentWeatherMain }}
            </div>
            <div class="wind">
              <i class="fa fa-wind"></i> {{ configuration.currentWindSpeed | number: '1.0-0' }} km/h 
              <i class="fa fa-arrow-down" [style.transform]="'rotate(' + configuration.currentWindDeg + 'deg)'"></i>
            </div>
            <div class="hum">
              <i class="fa fa-droplet"></i> {{ configuration.currentHumidity | number: '1.0-0' }}%
            </div>

           
        </div>

      </div>



      <li class="nav-item" ngbDropdown placement="bottom-right" *ngIf="user?.name">
        <a class="nav-link pr-0" role="button" ngbDropdownToggle>
          <div class="media align-items-center">
            <span class="avatar avatar-sm rounded-circle">
              <img alt="Image placeholder" src="assets/img/theme/team-4-800x800.jpg">
            </span>
          </div>
        </a>
        <div class="dropdown-menu-arrow dropdown-menu-right" ngbDropdownMenu>
          <div class=" dropdown-header noti-title">
            <h6 class="text-overflow m-0">Welcome {{ user?.name }} !</h6>
          </div> 
          <!-- <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-single-02"></i>
            <span>My profile</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-settings-gear-65"></i>
            <span>Settings</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-calendar-grid-58"></i>
            <span>Activity</span>
          </a>
          <a routerLinkActive="active" [routerLink]="['/user-profile']" class="dropdown-item">
            <i class="ni ni-support-16"></i>
            <span>Support</span>
          </a> -->
          <div class="dropdown-divider"></div>
          <a href="/#/login" (click)="logout()" class="dropdown-item">
            <i class="ni ni-user-run"></i>
            <span>Logout</span>
          </a>
        </div>
      </li>
    </ul>
  </div>
</nav>
